<div class="screen-container">
	<div class="failed-container">
		<div>
			<p class="title-xs text-center font-serra">Paiement validé</p>
			<img class="card-img" src="img/skin/payment-valid.svg"/>
			<div class="action-container">
				<p class="mb-2 text-center opacity-60">
					Votre paiement a été validé avec succès.
				</p>
				<p class="mb-4 text-center opacity-60">
					Legend+ est maintenant actif.
				</p>
				<a href="#" [routerLink]="router.get('collect-home')" class="btn bg-white text-primary border-[#e5e5e5] mb-2">
					Accéder à Legend+
				</a>
			</div>
		</div>
	</div>
</div>